import React from "react";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import SearchForm from "./forms/FactTableFilterForm";
import {MainLeftTitle,CreateButton } from '../../../_uiComponents/WrapperComponents'
import CreateLookUpTableForm from "./forms/CreateLookupTableForm";


export const CreateLookupTable = () => {
    return (
        <>
            <div className='sbt-data-grid__wr'>
                <MainLeftTitle title="Create Lookup Table">
                    </MainLeftTitle>
                <CreateLookUpTableForm/>
            </div>
        </>
    )

}